import { cx } from 'class-variance-authority';

import Blocks, { HeroComponents } from '@blocks';
import Layout from '@components/Layout';

import styles from './templateStyles.module.css';

const DefaultTemplate = ({ content, menu, mainClassName }) => {
  const heroTheme = content?.hero?.theme || null;

  return (
    <Layout heroTheme={heroTheme} menu={menu}>
      {content?.hero &&
        (() => {
          const Component = HeroComponents[content.hero.type];
          return Component ? <Component {...content.hero} /> : null;
        })()}
      <main className={cx(styles.main, mainClassName)}>
        {content?.blocks?.map((block, i) => {
          const Block = Blocks[block.type];
          // make sure that keys are unique across pages otherwise state will be shared
          const key = block._key ? block._key : i;
          return Block ? <Block key={key} {...block} /> : null;
        })}
      </main>
    </Layout>
  );
};

export default DefaultTemplate;
